import React from "react";
import SectorCRUDTable from "@/components/SectorCRUDTable";
import { Car } from "lucide-react";

const STATUS_LABELS = {
  en_cours: "En diagnostic",
  devis_envoye: "Devis envoyé",
  en_reparation: "En réparation",
  termine: "Terminé",
  retire: "Retiré",
};
const STATUS_COLORS = {
  en_cours: "#D97706",
  devis_envoye: "#002FA7",
  en_reparation: "#7C3AED",
  termine: "#059669",
  retire: "#868E96",
};

export default function ChefVehicules() {
  return (
    <SectorCRUDTable
      endpoint="/chef/secteur/vehicules"
      eyebrow="Garage · Véhicules"
      title="Véhicules confiés"
      sub="Suivez chaque véhicule : diagnostic, devis, réparation, sortie."
      testidPrefix="vehicule"
      allowEdit
      defaultRow={() => ({ immatriculation: "", marque: "", modele: "", proprietaire: "", telephone: "", date_depot: new Date().toISOString().slice(0, 10), date_sortie_prevue: "", diagnostic: "", status: "en_cours", devis: 0, kilometrage: 0, notes: "" })}
      columns={[
        { key: "immatriculation", label: "Immat.", width: "120px", render: (v) => <span className="font-mono font-bold uppercase">{v}</span> },
        { key: "marque", label: "Véhicule", render: (v, row) => `${v} ${row.modele || ""}` },
        { key: "proprietaire", label: "Propriétaire", width: "160px" },
        { key: "date_depot", label: "Dépôt", width: "110px", render: (v) => v ? new Date(v).toLocaleDateString("fr-FR") : "—" },
        { key: "devis", label: "Devis", width: "100px", render: (v) => <span className="font-mono">{(v || 0).toFixed(2)} €</span> },
        { key: "status", label: "Statut", width: "130px", render: (v) => (
          <span className="text-[9px] uppercase font-bold px-2 py-0.5" style={{ color: STATUS_COLORS[v], background: `${STATUS_COLORS[v]}15` }}>{STATUS_LABELS[v] || v}</span>
        )},
      ]}
      fields={[
        { key: "immatriculation", label: "Immatriculation", span: 4, required: true, placeholder: "AB-123-CD" },
        { key: "marque", label: "Marque", span: 4, required: true },
        { key: "modele", label: "Modèle", span: 4, required: true },
        { key: "proprietaire", label: "Propriétaire", span: 6, required: true },
        { key: "telephone", label: "Téléphone", span: 6 },
        { key: "date_depot", label: "Date dépôt", type: "date", span: 4, required: true },
        { key: "date_sortie_prevue", label: "Sortie prévue", type: "date", span: 4 },
        { key: "kilometrage", label: "Kilométrage", type: "number", span: 4 },
        { key: "status", label: "Statut", type: "select", span: 6, options: Object.entries(STATUS_LABELS).map(([v, l]) => ({ value: v, label: l })) },
        { key: "devis", label: "Montant devis (€)", type: "number", step: "0.01", span: 6 },
        { key: "diagnostic", label: "Diagnostic", type: "textarea", span: 12 },
        { key: "notes", label: "Notes internes", type: "textarea", span: 12 },
      ]}
      emptyIcon={Car}
      emptyText="Aucun véhicule. Cliquez sur Ajouter pour enregistrer un dépôt."
    />
  );
}
